import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import Flatpickr from "react-flatpickr";

import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import *  as Yup from 'yup'
import FormProvider from '../../../FunctionalComponent/FormElement/FormProvider';
import RHFTextField from '../../../FunctionalComponent/FormElement/RHTextField';
import { toast } from 'react-toastify';
import { useUpdateUserMutation } from '../../../Redux/auth/authApi';
import { userInfo } from '../../../Redux/auth/authSlice';

const stepOneSchema = Yup.object().shape({

});

const validateWith = {
    shouldDirty: true,
    shouldTouch: true,
    shouldValidate: true,
}


const PersonalInformation = () => {

    const [updateUserFn, { isLoading, isSuccess, error, data }] = useUpdateUserMutation()

    const defaultValues = {

        "firstName": "",

        "lastName": "",

        "profileImage": '',
        email: "",
        phone: "",
        createdAt: ""

    }


    const methods = useForm({
        resolver: yupResolver(stepOneSchema),
        defaultValues,
        mode: 'all',
    });

    const {

        setError,
        setValue,
        handleSubmit,
        getValues,
        formState: { errors },
    } = methods;

    const onSubmit = async (data) => {
        try {

            // setProductStep('STEP2')

            updateUserFn({ ...data });


        } catch (error) {

            setError("afterSubmit", {
                ...error,
                message: error.message,
            });
        }
    };

    const dispatch = useDispatch()



    useEffect(() => {
        if (isSuccess) {
            const message = data?.message || "Product created successfully";
            toast.success(message);




        }
        if (error) {
            if ('data' in error) {
                const errorData = error;
                toast.error(errorData.data.message);

            }
        }
    }, [data, isSuccess, error]);

    const user = useSelector(userInfo);
    const [selectedDate, setSelectedDate] = useState(new Date());

    useEffect(() => {
        if (user?.id) {
            for (const key in defaultValues) {
                if (Object.hasOwnProperty.call(defaultValues, key)) {
                    setValue(key, user?.[key])

                }
            }

            setSelectedDate(new Date(getValues('createdAt')))
        }

    }, [user])



    return (
        <React.Fragment>
            <Row>
                <Col lg={4}>
                    <h5 className="fs-16">Personal Information</h5>
                    <p className="text-muted mb-lg-0">Personal Identifiable Information (PII) is defined as representation of information that permits the identity of an individual to whom the information applies to be reasonably inferred by either direct or indirect means.</p>
                </Col>
                <Col lg={8}>
                    <Card>

                        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>


                            <Card.Body>
                                <Row className="g-3">
                                    <Col lg={6}>
                                        {/* <div> */}
                                        <RHFTextField name='firstName' label='first Name' required />

                                        {/* <Form.Label htmlFor="firstName">First Name <span className="text-danger">*</span></Form.Label>
                                            <Form.Control type="text" id="firstName" placeholder="Enter your first name" defaultValue="Raquel" /> */}
                                        {/* </div> */}
                                    </Col>
                                    <Col lg={6}>
                                        {/* <div> */}
                                        <RHFTextField name='lastName' label='Last name' required />

                                        {/* <Form.Label htmlFor="lastName">Last Name <span className="text-danger">*</span></Form.Label>
                                            <Form.Control type="text" id="lastName" placeholder="Enter your last name" defaultValue="Murillo" /> */}
                                        {/* </div> */}
                                    </Col>
                                    <Col lg={4}>
                                        <div>
                                            <RHFTextField name='email' label='Email Address' readOnly required disabled />

                                            {/* <Form.Label htmlFor="emailInput">Email Address <span className="text-danger">*</span></Form.Label>
                                            <Form.Control readOnly type="text" id="emailInput" placeholder="name@toner.com" defaultValue="raquel@toner.com" /> */}
                                        </div>
                                    </Col>
                                    <Col lg={4}>
                                        <div>


                                            <RHFTextField name='phone' label='Phone Number' disabled readOnly required />


                                            {/* <Form.Label htmlFor="phoneInput">Phone Number</Form.Label>
                                            <Form.Control type="text" id="phoneInput" placeholder="Enter phone number" defaultValue="+(235) 01234 5678" /> */}
                                        </div>
                                    </Col>
                                    <Col lg={4}>
                                        <div>
                                            <Form.Label htmlFor="birdthdatInput">Joining Date</Form.Label>
                                            <Flatpickr
                                                className="form-control flatpickr-input"
                                                placeholder='Select Date'
                                                options={{
                                                    mode: "range",
                                                    dateFormat: "d M, Y",
                                                    defaultDate: getValues('createdAt'),

                                                }}

                                                value={selectedDate}


                                            // disabled
                                            />
                                        </div>
                                    </Col>
                                    {/* <Col lg={6}>
                                    <div>
                                        <Form.Label htmlFor="designationInput">Designation</Form.Label>
                                        <Form.Control type="text" id="designationInput" placeholder="Designation" defaultValue="Sales & Marketing Manager"/>
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div>
                                        <Form.Label htmlFor="websiteInput1">Website</Form.Label>
                                        <Form.Control type="text" id="websiteInput1" placeholder="www.example.com" defaultValue="www.toner.com"/>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div>
                                        <Form.Label htmlFor="cityInput">City</Form.Label>
                                        <Form.Control type="text" id="cityInput" placeholder="City" defaultValue="Phoenix"/>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div>
                                        <Form.Label htmlFor="countryInput">Country</Form.Label>
                                        <Form.Control type="text" id="countryInput" placeholder="Country" defaultValue="United States"/>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div>
                                        <Form.Label htmlFor="zipcodeInput">Zip Code</Form.Label>
                                        <Form.Control type="text" id="zipcodeInput" placeholder="Enter zipcode" defaultValue="90011"/>
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <div className="text-end">
                                        <Button variant='secondary' type="submit">Update Profile</Button>
                                    </div>
                                </Col> */}
                                    <Col lg={12}>
                                        <div className="text-end">
                                            <Button variant='secondary' type="submit">Update Profile</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </FormProvider>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default PersonalInformation;
